/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IReferenceNode } from '../../../core/models/IReferenceNode';
import { IExample } from '../../../core/models/common/IExample';
import { IExampleParent } from '../../../core/models/common/IExampleParent';
import { IExamplesParent } from '../../../core/models/common/IExamplesParent';
import { OasHeader } from '../../models/OasHeader';
import { Oas30Schema } from './Oas30Schema';
import { Oas30MediaType } from './Oas30MediaType';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';
import { Oas30Example } from './Oas30Example';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends OasHeader
 * @author eric.wittmann@gmail.com
 */
export class Oas30Header extends OasHeader implements IReferenceNode, IExampleParent, IExamplesParent {
    public $ref : string;

    public required : boolean;

    public deprecated : boolean;

    public allowEmptyValue : boolean;

    public style : string;

    public explode : boolean;

    public allowReserved : boolean;

    public schema : Oas30Schema;

    public example : any;

    public examples : any = <any>({});

    public content : any = <any>({});

    public constructor(name : string) {
        super(name);
        if(this.$ref===undefined) this.$ref = null;
        if(this.required===undefined) this.required = null;
        if(this.deprecated===undefined) this.deprecated = null;
        if(this.allowEmptyValue===undefined) this.allowEmptyValue = null;
        if(this.style===undefined) this.style = null;
        if(this.explode===undefined) this.explode = null;
        if(this.allowReserved===undefined) this.allowReserved = null;
        if(this.schema===undefined) this.schema = null;
        if(this.example===undefined) this.example = null;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    /**
     * Creates a child items model.
     * @return {Oas30Schema}
     */
    public createSchema() : Oas30Schema {
        let rval : Oas30Schema = new Oas30Schema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates a child Example model.
     * @param {string} name
     * @return {Oas30Example}
     */
    public createExample(name : string) : Oas30Example {
        let rval : Oas30Example = new Oas30Example(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds the Example to the map of examples.
     * @param {*} example
     */
    public addExample(example : IExample) {
        /* put */(this.examples[example.getName()] = example);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IExampleParent#setExample(java.lang.Object)
     * @param {*} example
     */
    public setExample(example : any) {
        this.example = example;
    }

    /**
     * Removes an Example and returns it.
     * @param {string} name
     * @return {*}
     */
    public removeExample(name : string) : IExample {
        return /* remove */(map => { let deleted = this.examples[name];delete this.examples[name];return deleted;})(this.examples);
    }

    public getExample$java_lang_String(name : string) : IExample {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.examples, name);
    }

    /**
     * Gets a single example by name.
     * @param {string} name
     * @return {*}
     */
    public getExample(name? : any) : any {
        if(((typeof name === 'string') || name === null)) {
            return <any>this.getExample$java_lang_String(name);
        } else if(name === undefined) {
            return <any>this.getExample$();
        } else throw new Error('invalid overload');
    }

    public getExample$() : any {
        return this.example;
    }

    /**
     * Gets all examples.
     * @return {*[]}
     */
    public getExamples() : Array<IExample> {
        let rval : Array<IExample> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.examples));
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IExamplesParent#clearExamples()
     */
    public clearExamples() {
        this.examples = <any>({});
    }

    /**
     * Creates a media type.
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public createMediaType(name : string) : Oas30MediaType {
        let rval : Oas30MediaType = new Oas30MediaType(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a media type.
     * @param {string} name
     * @param {Oas30MediaType} mediaType
     */
    public addMediaType(name : string, mediaType : Oas30MediaType) {
        /* put */(this.content[name] = mediaType);
    }

    /**
     * Gets a single media type by name.
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public getMediaType(name : string) : Oas30MediaType {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.content, name);
    }

    /**
     * Removes a single media type and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public removeMediaType(name : string) : Oas30MediaType {
        return /* remove */(map => { let deleted = this.content[name];delete this.content[name];return deleted;})(this.content);
    }

    /**
     * Gets a list of all media types.
     * @return {Oas30MediaType[]}
     */
    public getMediaTypes() : Array<Oas30MediaType> {
        let rval : Array<Oas30MediaType> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.content));
        return rval;
    }
}
Oas30Header["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Header";
Oas30Header["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IExampleParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExamplesParent","io.apicurio.datamodels.core.models.common.INamed"];




